$(document).ready(function(){

    $('.tabs .tab').each(function(i){
        $(this)
            .data('ordinal', i)
            .click(function(){
                if(!$(this).hasClass('active'))
                {
                    $(this).parent().find('> .tab').removeClass('active');
                    $(this).addClass('active');
                    $('.tabcontent').hide().filter('.tab_'+i).fadeIn(300);
                }
            });
            
        if ($(this).hasClass('active')){
            $('.tab_'+i).toggle();
        }
    });

});